import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  Checkbox, TextField,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  Input,
  Label,
} from '@ipc/ipc-components';
import { Autocomplete } from '@material-ui/lab';
import {
  getAllDataLocationsList,
  getAllImpcLocationsList, isEmailAddressDuplicate,
} from '../../redux/selectors/MrdContactsSelectors';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserSelectors';
import {
  checkEmailAddressRequestActionCreator,
  getAllDataLocationsRequestActionCreator,
  getAllImpcLocationsRequestActionCreator,
  clearEmailDuplicateActionCreator,
} from '../../redux/actions/ContactsActions';
import { MrdContactsCreateDialogStyles } from './MrdContactsCreateDialog.styles';

function MrdContactsCreateDialog(props) {
  const {
    isOpen,
    userRole,
    impcLocationList,
    dataLocationList,
    closeDialog,
    getDataLocationList,
    getImpcLocationList,
    addNewContact,
    selectedImpc,
    checkEmailAddress,
    isEmailDuplicate,
    isWizard,
    isIPCView,
    clearEmailDuplicate,
  } = props;

  useEffect(() => {
    getImpcLocationList();
    if (userRole.includes('IPC_ADMIN')) {
      getDataLocationList();
    }
  }, []);
  const [email, setEmail] = useState(null);
  const [enteredFirstName, setFirstName] = useState(null);
  const [enteredLastName, setLastName] = useState(null);
  const [phone, setPhone] = useState(null);
  const [notifyForFailure, setNotifyForFailure] = useState(false);
  const [impcLocation, setImpcLocations] = useState(selectedImpc !== null ? [{ inputValue: selectedImpc, title: selectedImpc }] : []);
  const [isIpcContact, setIsIpcContact] = useState((userRole.includes('IPC_ADMIN') && isIPCView) || false);
  const [dataLocation, setDataLocations] = useState([]);
  const [emailError, setEmailError] = useState(false);

  const isFormValid = () => !(email === null
    || !email.includes('@')
    || !email.includes('.')
    || email.includes(' ')
    || enteredFirstName === null
    || enteredLastName === null
    || enteredFirstName === ''
    || enteredLastName === ''
    || emailError
    || (!isIpcContact && (userRole.includes('IPC_ADMIN') && impcLocation.length === 0 && dataLocation.length === 0))
    || (userRole.includes('OPER_ADMIN') && impcLocation.length === 0)
    || (isWizard && isEmailDuplicate)
  );
  const handleEmail = (e) => {
    const isEmailValid = e.target.value.includes('@') && e.target.value.includes('.') && (e.target.value.indexOf('@') > 0) && (!e.target.value.endsWith('.')) && !(e.target.value.includes(' '));
    if (isEmailValid) {
      checkEmailAddress({ email: e.target.value });
      setEmailError(false);
    } else {
      setEmailError(true);
    }
    setEmail(e.target.value);
  };

  const handleFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastName = (e) => {
    setLastName(e.target.value);
  };

  const handlePhone = (e) => {
    setPhone(e.target.value);
  };

  const phoneKeyPress = (e) => {
    const phoneRegex = /[0-9\d\s-+/()\\\][]/g;
    if (!phoneRegex.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleNotifyForFailure = (e) => {
    setNotifyForFailure(e.target.checked);
  };

  const handleImpcLocation = (event, inputValue) => {
    setImpcLocations(inputValue);
  };

  const handleIsIpcContact = (e) => {
    setIsIpcContact(e.target.checked);
  };

  const handleDataLocation = (event, inputValue) => {
    setDataLocations(inputValue);
  };

  const confirmSave = () => {
    const impcLoc = impcLocation.map((impc) => impc.inputValue);
    const dataLoc = dataLocation.map((data) => data.inputValue);
    const requestData = {
      dataLocations: dataLoc,
      emailAddress: email,
      firstName: enteredFirstName,
      impcLocations: impcLoc,
      ipcContact: isIpcContact,
      lastName: enteredLastName,
      notifyOnFailure: notifyForFailure,
      phoneNumber: phone,
      isEmailDuplicate,
    };
    addNewContact(requestData);
  };

  const handleCancel = () => {
    clearEmailDuplicate();
    closeDialog();
  };
  return (
    <Dialog onClose={handleCancel} aria-labelledby="simple-dialog-title" open={isOpen}>
      <MrdContactsCreateDialogStyles>
        <DialogTitle id="simple-dialog-title">New Contact</DialogTitle>
        <div>
          <table className="contact-form-details">
            <tbody>
              <tr>
                <td className="contact-form-input-details">
                  <Label>Email</Label>
                </td>
                <td className="contact-form-input-details">
                  <Input
                    type="text"
                    value={email}
                    maxLength={45}
                    required
                    onChange={handleEmail}
                    size={45}
                    placeholder="example@example.com"
                    inputProps={{ mask: 'x@x.x' }}
                  />
                </td>
                {(isEmailDuplicate && !isWizard) && (
                  <td className="contact-form-input-details" style={{ color: 'red', minWidth: '210px' }}>
                    {userRole.includes('IPC') ? 'This email address is not unique. You will be given an option to edit the existing contact.'
                      : 'This email address is not unique. You will be given an option to add existing contact to the viewed contact list.' }
                  </td>
                )}
                {(isEmailDuplicate && isWizard) && (
                  <td className="contact-form-input-details" style={{ color: 'red', minWidth: '210px' }}>
                    This email address is not unique.
                  </td>
                )}
              </tr>
              {emailError && (
                <tr>
                  <td />
                  <td className="contact-form-input-details" style={{ color: 'red' }}>Please enter a valid e-mail address</td>
                </tr>
              )}
              <tr>
                <td className="contact-form-input-details">
                  <Label>First name</Label>
                </td>
                <td className="contact-form-input-details">
                  <Input
                    type="text"
                    value={enteredFirstName}
                    maxLength={30}
                    size={45}
                    onChange={handleFirstName}
                  />
                </td>
              </tr>
              <tr>
                <td className="contact-form-input-details">
                  <Label>Last name</Label>
                </td>
                <td className="contact-form-input-details">
                  <Input
                    type="text"
                    value={enteredLastName}
                    maxLength={30}
                    size={45}
                    onChange={handleLastName}
                  />
                </td>
              </tr>
              <tr>
                <td className="contact-form-input-details">
                  <Label>Phone</Label>
                </td>
                <td className="contact-form-input-details">
                  <Input
                    type="tel"
                    value={phone}
                    maxLength={20}
                    size={45}
                    onChange={handlePhone}
                    onKeyPress={(e) => phoneKeyPress(e)}
                  />
                </td>
              </tr>
              <tr>
                <td className="contact-form-input-details">
                  <Label>Notify for failure</Label>
                </td>
                <td className="contact-form-input-details">
                  <Checkbox
                    checked={notifyForFailure}
                    onChange={handleNotifyForFailure}
                  />
                </td>
              </tr>
              <tr>
                <td className="contact-form-input-details">
                  <Label>IMPC Locations</Label>
                </td>
                <td className="contact-form-input-details">
                  <Autocomplete
                    multiple
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="tags-outlined"
                    value={impcLocation}
                    filterSelectedOptions
                    getOptionSelected={(option, value) => option.title === value.title}
                    onChange={handleImpcLocation}
                    defaultValue={impcLocation.length === 1 ? [impcLocation[0]] : null}
                    options={impcLocationList.map((element) => ({
                      inputValue: element.impc,
                      title: element.impc,
                    }))}
                    getOptionLabel={(option) => option.title}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                      />
                    )}
                  />
                </td>
              </tr>
              {userRole.includes('IPC') && (
                <tr>
                  <td className="contact-form-input-details">
                    <Label>
                      IPC Contact
                    </Label>
                  </td>
                  <td className="contact-form-input-details">
                    <Checkbox
                      checked={isIpcContact}
                      onChange={handleIsIpcContact}
                    />
                  </td>
                </tr>
              )}
              {userRole.includes('IPC') && (
                <tr>
                  <td className="contact-form-input-details">
                    <Label>
                      Data Locations
                    </Label>
                  </td>
                  <td className="contact-form-input-details">
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      value={dataLocation}
                      onChange={handleDataLocation}
                      filterSelectedOptions
                      getOptionSelected={(option, value) => option.title === value.title}
                      size="small"
                      options={dataLocationList.map((element) => ({
                        inputValue: element.id,
                        title: element.dataLocation,
                      }))}
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                        />
                      )}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={handleCancel}>Cancel</Button>
          <Button
            className={`primary-button-${(!isWizard && isEmailDuplicate) ? false : !isFormValid()} action`}
            disabled={(!isWizard && isEmailDuplicate) ? false : !isFormValid()}
            id="save"
            onClick={confirmSave}
          >
            Save
          </Button>
        </div>
      </MrdContactsCreateDialogStyles>
    </Dialog>
  );
}
function mapStateToProps(state) {
  return {
    impcLocationList: getAllImpcLocationsList(state),
    dataLocationList: getAllDataLocationsList(state),
    userRole: getUserRole(state),
    isEmailDuplicate: isEmailAddressDuplicate(state),
  };
}
MrdContactsCreateDialog.propTypes = {
  isOpen: PropTypes.bool,
  userRole: PropTypes.string,
  impcLocationList: PropTypes.arrayOf(PropTypes.object),
  dataLocationList: PropTypes.arrayOf(PropTypes.object),
  allContacts: PropTypes.arrayOf(PropTypes.object),
  closeDialog: PropTypes.func.isRequired,
  getDataLocationList: PropTypes.func,
  getImpcLocationList: PropTypes.func,
  addNewContact: PropTypes.func,
  selectedImpc: PropTypes.string,
  checkEmailAddress: PropTypes.func,
  isEmailDuplicate: PropTypes.number,
  isWizard: PropTypes.bool,
  isIPCView: PropTypes.bool,
  clearEmailDuplicate: PropTypes.func,
};

MrdContactsCreateDialog.defaultProps = {
  isWizard: false,
  isIPCView: false,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getDataLocationList: getAllDataLocationsRequestActionCreator,
  getImpcLocationList: getAllImpcLocationsRequestActionCreator,
  checkEmailAddress: checkEmailAddressRequestActionCreator,
  clearEmailDuplicate: clearEmailDuplicateActionCreator,
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MrdContactsCreateDialog);
